import { useEffect } from 'react';
import { useKeepWindowScrollOnReturn } from '@/hooks/useKeepWindowScrollOnReturn';
import { useLastViewedRowStore, type ViewedRowList } from '@/store/lastViewedRow.store';

export function useRememberViewedRow(
  list: ViewedRowList,
  rowId: number | null,
  parentId: number | null = null,
) {
  const rememberViewedRow = useLastViewedRowStore((state) => state.rememberViewedRow);

  useEffect(() => {
    if (rowId === null) return;
    rememberViewedRow(list, { rowId, parentId });
  }, [list, rowId, parentId, rememberViewedRow]);
}

export function useRevealLastViewedRow(
  list: ViewedRowList,
  parentId: number | null = null,
): number | null {
  const viewedRow = useLastViewedRowStore((state) => state.viewedRowByList[list]);
  const lastViewedRowId = viewedRow?.parentId === parentId ? viewedRow.rowId : null;

  useKeepWindowScrollOnReturn(lastViewedRowId !== null);

  return lastViewedRowId;
}
